"use client";
import React, { Fragment, useEffect, useState } from "react";
import DataTableClient from "@/components/ui/custom/datatable/client";
import SeasonsTableServer from "@/components/ui/custom/datatable/server/seasons-table";
import { columnDef } from "../lib/column-def";
import { getSeasonSnapshot } from "../lib/utils";

import { AnimatedCircularProgressBar } from "@/components/ui/custom/animated-progress";

const SeasonsTable = ({
  season,
  selectedSeasonData,
  walletAddress,
  setSnapshotFrom,
  setSnapshotTo,
  setCurrentUserResult,
}) => {
  const [loading, setLoading] = useState(false);
  const [diffResult, setDiffResult] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (!season) return;

      setLoading(true);
      setProgress(0);
      try {
        const data = await getSeasonSnapshot(
          season,
          walletAddress,
          setSnapshotFrom,
          setSnapshotTo,
          setProgress
        );
        setDiffResult(data);
        setCurrentUserResult(data?.CurrentUser?.userResults || null);
        setCurrentUser(data?.CurrentUser?.userResults || null);
      } catch (error) {
        setDiffResult([]);
        setCurrentUserResult(null);
      } finally {
        setLoading(false);
        setProgress(100);
      }
    };

    fetchData();
  }, [season, walletAddress, setSnapshotFrom, setSnapshotTo]);

  // console.log(season)

  return (
    <>
      {loading ? (
        <div className="mt-4 mb-6">
          <AnimatedCircularProgressBar
            max={100}
            value={progress}
            min={0}
            gaugePrimaryColor="#fe5000"
            gaugeSecondaryColor="#333"
            className="w-full mt-4"
          />
          {/* <LogoLoading /> */}
          {/* <Progress value={progress} className="w-full mt-4" /> */}
          {/* <p className="text-sm text-gray-500 text-center mt-2">Processing {progress}%</p> */}
        </div>
      ) : (
        <Fragment>
          {diffResult && !loading && (
            <div className="mt-4 mb-6">
              {/* <DataTableClient
                currentUser={currentUser}
                data={diffResult}
                columnDef={columnDef}
              /> */}
              <SeasonsTableServer
                selectedSeasonData={selectedSeasonData}
                payload={{
                  table: `seasons_difference_${season.id}`,
                  season_id: season.id,
                  walletAddress: walletAddress,
                }}
                columnDef={columnDef}
              />
            </div>
          )}
        </Fragment>
      )}
    </>
  );
};

export default SeasonsTable;
